var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9983 1.61328C13.9985 5.11328 14.5561 8.10086 15.4983 10.6133C16.9984 14.6133 16.9984 19.1133 14.4984 22.6133",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5222 1.61328C3.52197 5.11328 2.9644 8.10086 2.0222 10.6133C0.522129 14.6133 0.522129 19.1133 3.02213 22.6133",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99805 4.11328C3.49805 3.77995 5.39805 3.11328 8.99805 3.11328C12.598 3.11328 14.1647 3.77995 14.498 4.11328",
    stroke: "#1A1A1A",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99805 12.1133C2.60674 12.4466 4.91979 13.1133 9.30239 13.1133C13.685 13.1133 15.5922 12.4466 15.998 12.1133",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.998047 15.1133L8.99805 18.6133L16.498 15.1133",
    stroke: "#1A1A1A",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99805 18.6133V22.6133",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyShape);
export default __webpack_public_path__ + "static/media/body_shape.05730034e498b34091dc8771cb813d18.svg";
export { ForwardRef as ReactComponent };